/**
 * 门户音频默认配置数据
 */
export const home = [
  {},
  {
    styleId:2,
    width: 600,
    height: 124,
    paddingTop: 26,
    paddingRight: 60,
    paddingLeft: 60,
    showControls: true,
    iconPlaySrc: "https://p.ananas.chaoxing.com/star3/origin/d015d62c673e7e59d3698329df16516f.jpg",
    iconPauseSrc: "https://p.ananas.chaoxing.com/star3/origin/0c9da8c7b9333634b8a4f8d4e0fbb9b9.jpg",
    iconFastSrc: "https://p.ananas.chaoxing.com/star3/origin/e3683e1081e7bb7ea17b27d49e3e826a.jpg",
    iconBackSrc: "https://p.ananas.chaoxing.com/star3/origin/2f3a146021948da978accfcff792b541.jpg",
    background: [
      {
        color: "#F7F8FA",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    barBackground: [
      {
        color: "#E9E9E9",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    progressBackground: [
      {
        color: "#E9E9E9",
        isThemeColor: true,
        label: "颜色",
        type: "color"
      }
    ],
    borderWidth: 1,
    borderColor: "#E9E9E9",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    barBorderTopLeftRadius: 10,
    barBorderTopRightRadius: 10,
    barBorderBottomLeftRadius: 10,
    barBorderBottomRightRadius: 10,
  }
]

/**
 * 大屏音频默认配置数据
 */
export const bs = [{}]

/**
 * app音频默认配置数据
 */
export const appHome = [{}]

